import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import styled from "styled-components";
import { useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import moment from "moment";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { IndianCurrency, NumberInWord } from "app/utils/helper";
import CustomLoader from "app/components/common/CustomLoader";
import SchoolPrintUtilityHeader from "app/components/common/SchoolPrintUtilityHeader";
import { Helmet } from "react-helmet";
import { getUniformInvoice } from "app/services/ledgerAccount";
import dayjs from "dayjs";

const LabelText3 = ({ label, text }) => {
  return (
    <>
      <Grid item xs={2}>
        <Typography sx={{ fontWeight: 600, fontSize: "10px" }}>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={5.5}>
        <Typography sx={{ fontWeight: 400, fontSize: "10px" }}>
          : {text}
        </Typography>
      </Grid>
    </>
  );
};

const LabelText4 = ({ label, text }) => {
  return (
    <>
      <Grid item xs={1.5}>
        <Typography sx={{ fontWeight: 600, fontSize: "10px" }}>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={2.5}>
        <Typography sx={{ fontWeight: 400, fontSize: "10px" }}>
          : {text}
        </Typography>
      </Grid>
    </>
  );
};

const LabelText2 = ({ label, text }) => {
  return (
    <>
      <Grid item xs={3}>
        <Typography sx={{ fontWeight: 600, fontSize: "10px" }}>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography sx={{ fontWeight: 400, fontSize: "10px" }}>
          : {text}
        </Typography>
      </Grid>
    </>
  );
};

const LabelText = ({ label, text }) => {
  return (
    <>
      <Grid item xs={2}>
        <Typography sx={{ fontWeight: 600, fontSize: "10px" }}>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography sx={{ fontWeight: 400, fontSize: "10px" }}>
          : {text}
        </Typography>
      </Grid>
    </>
  );
};

export default function UniformPaySlip() {
  const invoicePrintRef = useRef(null);
  const [data, setData] = useState({});
  const { id } = useParams();

  const handlePrint = useReactToPrint({
    content: () => invoicePrintRef.current,
  });

  const invoiceNumber = String(id).replace(/ /g, "/");

  const { isLoading, isFetching } = useQuery({
    queryKey: ["getUniformInvoice", invoiceNumber],
    queryFn: () => getUniformInvoice({ invoiceNumber }),
    onSuccess: (res) => setData(res?.data?.obj ?? {}),
    onError: (err) => toast.error(err?.response?.data?.message ?? "Failed"),
    enabled: Boolean(invoiceNumber),
  });

  const InvoiceDetail = ({ text }) => {
    return (
      <LeftSideDiv className="uniform-slip">
        <SchoolPrintUtilityHeader data={data?.schoolFirm} />
        <InvoiceHeader>
          <div style={{ width: "100%" }}>
            <div
              className="uniform-slip__title"
              style={{
                width: "100%",
                fontWeight: "600",
                fontSize: "16px",
                textTransform: "capitalize",
                textAlign: "center",
                color: "#FFFFFF",
                backgroundColor: "#0C4B7E",
              }}
            >
              {text}
              {data?.session ? ` - ${data?.session}` : ""}
            </div>
          </div>
        </InvoiceHeader>

        <InvoiceBody>
          <Stack direction="row" justifyContent="space-between">
            <LabelText3
              label="Invoice No."
              text={data?.invoiceNumber ?? "--"}
            />
            <LabelText4
              label="Collection Date"
              text={
                data?.collectionDate
                  ? moment(new Date(data?.collectionDate)).format("DD/MM/YYYY")
                  : "--"
              }
            />
          </Stack>

          <Box sx={{ backgroundColor: "#000", my: 0.3, height: "1px" }} />

          <Grid container sx={{ px: 1 }}>
            <LabelText2
              label="Student's Name"
              text={data?.studentDetail?.studentName ?? "--"}
            />
            <LabelText
              label="Admission No."
              text={data?.studentDetail?.admissionNumber ?? "--"}
            />
            <LabelText2
              label="ClassName"
              text={`${data?.studentDetail?.className ?? "--"}-${
                data?.studentDetail?.stream ?? "--"
              }-${data?.studentDetail?.section ?? "--"}`}
            />
          </Grid>

          <Grid container sx={{ background: "#ffaf0d", py: 1, px: 1, mt: 0.5 }}>
            <Grid item xs={2}>
              <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                Discription
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                UOM
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                Quantity
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                Rate
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                Discount
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                Amount
              </Typography>
            </Grid>
          </Grid>

          {(data?.invoiceItems ?? []).map((item, ind) => (
            <Grid
              key={ind}
              container
              sx={{
                py: 0.1,
                mb: 1,
                px: 1,
                padding: "5px",
                background: "rgba(61, 57, 137, 0.1)",
              }}
            >
              <Grid item xs={2}>
                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                  {item?.description ?? "--"}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                  {item?.UOM ?? item?.size ?? "--"}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                  {item?.quantity ?? 0}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                  {IndianCurrency(Number(item?.rate ?? 0))}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                  {IndianCurrency(Number(item?.discountAmount ?? 0))}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                  {IndianCurrency(Number(item?.itemAmount ?? 0))}
                </Typography>
              </Grid>
            </Grid>
          ))}

          <Grid container sx={{ px: 1, pt: 0.3, borderTop: "1px solid #000" }}>
            <Grid item xs={8}>
              <Typography sx={{ fontSize: "10px" }}>
                Discount Remarks:{" "}
                <span style={{ fontWeight: 600 }}>
                  {data?.discountRemark ?? "--"}
                </span>
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                {IndianCurrency(Number(data?.totalDiscount ?? 0))}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                {IndianCurrency(Number(data?.totalAmount ?? 0))}
              </Typography>
            </Grid>
          </Grid>

          <Grid container sx={{ px: 1, pt: 0.3, borderTop: "1px solid #000" }}>
            <Grid item xs={9}>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Typography sx={{ fontSize: "10px" }}>
                    Paying Amount
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                    {IndianCurrency(Number(data?.paidAmount ?? 0))}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={3}>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Typography sx={{ fontSize: "10px" }}>Grand Total</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                    {IndianCurrency(
                      Number(data?.grandTotalAmount ?? data?.totalAmount ?? 0),
                    )}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ fontSize: "10px" }}>
                    Tax (if Any)
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                    {IndianCurrency(Number(data?.taxAmount ?? 0))}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container sx={{ px: 1, pt: 0.3, borderTop: "1px solid #000" }}>
            <Grid item xs={9}>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: 600 }}>Paid Amount</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ fontSize: "10px" }}>
                    {NumberInWord(Number(data?.paidAmount ?? 0))}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={3}>
              <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                {IndianCurrency(Number(data?.paidAmount ?? 0))}
              </Typography>
            </Grid>
          </Grid>

          <Box sx={{ backgroundColor: "#000", my: 0.3, height: "1px" }} />
          <Grid container sx={{ px: 1 }}>
            <Grid item xs={4}>
              <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>
                Payment Mode :{" "}
                {data?.paymentDetails
                  ? Object.keys(data?.paymentDetails)[0]
                  : "--"}
              </Typography>
            </Grid>
            {data?.paymentDetails?.UpiMode && (
              <Grid item xs={8}>
                <Stack direction={"row"} justifyContent={"space-around"}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                    UPI Number: {data?.paymentDetails?.UpiMode?.upiNumber}
                  </Typography>
                  <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                    Transaction ID:{" "}
                    {data?.paymentDetails?.UpiMode?.transactionId}
                  </Typography>
                  <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                    Amount: {data?.paymentDetails?.UpiMode?.amount}
                  </Typography>
                </Stack>
              </Grid>
            )}
            {data?.paymentDetails?.CardMode && (
              <Grid item xs={8}>
                <Stack direction={"row"} justifyContent={"space-around"}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                    Card Holder Name:{" "}
                    {data?.paymentDetails?.CardMode?.cardHolderName}
                  </Typography>
                  <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                    Card Number: {data?.paymentDetails?.CardMode?.cardNumber}
                  </Typography>
                  <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                    Amount: {data?.paymentDetails?.CardMode?.amount}
                  </Typography>
                </Stack>
              </Grid>
            )}
            {data?.paymentDetails?.ChequeMode && (
              <Grid item xs={8}>
                <Stack direction={"row"} justifyContent={"space-around"}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                    Cheque No.: {data?.paymentDetails?.ChequeMode?.chequeNumber}
                  </Typography>
                  <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                    Amount: {data?.paymentDetails?.ChequeMode?.amount}
                  </Typography>
                  <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                    Deposition Date:{" "}
                    {data?.paymentDetails?.ChequeMode?.depositionDate
                      ? dayjs(
                          data?.paymentDetails?.ChequeMode?.depositionDate,
                        ).format("DD MMM YYYY")
                      : "--"}
                  </Typography>
                </Stack>
              </Grid>
            )}
            {data?.paymentDetails?.NEFTMode && (
              <Grid item xs={8}>
                <Stack direction={"row"} justifyContent={"space-around"}>
                  <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>
                    Reference No.:{" "}
                    {data?.paymentDetails?.NEFTMode?.referenceNumber}
                  </Typography>
                  <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>
                    Amount: {data?.paymentDetails?.NEFTMode?.amount}
                  </Typography>
                  <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>
                    Transaction No.:{" "}
                    {data?.paymentDetails?.NEFTMode?.transactionNumber}
                  </Typography>
                </Stack>
              </Grid>
            )}
            {data?.paymentDetails?.CashMode && (
              <Grid item xs={8}>
                <Stack direction={"row"} justifyContent={"space-around"}>
                  <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>
                    Amount: {data?.paymentDetails?.CashMode?.amount}
                  </Typography>
                </Stack>
              </Grid>
            )}
          </Grid>

          <Box sx={{ backgroundColor: "#000", my: 0.3, height: "1px" }} />
          <Grid container sx={{ px: 1 }}>
            <Grid item xs={9}>
              <Typography sx={{ fontSize: "10px" }}>
                Balance Amount:{" "}
                <span style={{ color: "red" }}>
                  {IndianCurrency(Number(data?.balanceAmount ?? 0))}
                </span>{" "}
                <span style={{ color: "red", fontWeight: 600 }}>
                  ({data?.balanceRemark ?? "--"})
                </span>
              </Typography>
            </Grid>
          </Grid>

          <Box sx={{ backgroundColor: "#000", my: 0.3, height: "1px" }} />
          <Stack direction="row" justifyContent="space-between" sx={{ px: 1 }}>
            <Box>
              <Typography sx={{ fontSize: "10px" }}>
                Created By : {data?.createdBy?.personName ?? "--"}
              </Typography>
              <Typography sx={{ fontSize: "10px" }}>
                Created On :{" "}
                {data?.createdOn
                  ? dayjs(data?.createdOn).format("DD MMM YYYY")
                  : "--"}
              </Typography>
            </Box>
            <Box>
              <Typography sx={{ fontSize: "10px" }}>For,</Typography>
              <Typography sx={{ fontSize: "10px" }}>
                {data?.schoolName ?? "--"}
              </Typography>
              <Typography sx={{ fontSize: "10px", pt: 2, pb: 1 }}>
                Authorised Sign.
              </Typography>
            </Box>
          </Stack>
        </InvoiceBody>
      </LeftSideDiv>
    );
  };

  return (
    <Box>
      <Helmet>
        <title>Uniform Invoice</title>
      </Helmet>

      <CustomLoader show={isLoading || isFetching} />

      <Stack direction={"row"} justifyContent={"center"} sx={{ pt: 2 }}>
        <Button
          variant="contained"
          color="secondary"
          size="large"
          sx={{ mb: 1 }}
          onClick={() => handlePrint()}
        >
          Print
        </Button>
      </Stack>

      <Wrapper>
        <Stack
          sx={{ width: "60%", m: "auto" }}
          direction={"row"}
          justifyContent={"center"}
        >
          <Box ref={invoicePrintRef}>
            <InvoiceDetail text={"Uniform Invoice"} />
          </Box>
        </Stack>
      </Wrapper>
    </Box>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 1.5rem;
  padding-top: 1rem;
  align-items: center;

  @media print {
    padding: 0;
    .uniform-slip {
      font-size: 8.5px !important;
    }
    .uniform-slip * {
      font-size: 8.5px !important;
      line-height: 1.1 !important;
    }
    .uniform-slip__title {
      font-size: 11px !important;
    }
  }
`;

const LeftSideDiv = styled.div`
  margin: 2px;
  height: 100%;
  border: 1px solid black;
`;

const InvoiceHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const InvoiceBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
